<template>
 <router-view></router-view>
 <HelpdeskChatbot v-if="showPublicChatbot" portal="procuring-entity" />
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import HelpdeskChatbot from './components/helpdesk-chatbot.vue';

export default {
  name: 'App',
  components: {
    HelpdeskChatbot
  },
  setup() {
    const route = useRoute();
    const publicChatbotPaths = ['/login', '/logout', '/forgot-password', '/reset-password', '/auth/signin', '/auth/logout', '/auth/reset-pwd'];
    const showPublicChatbot = computed(() => publicChatbotPaths.includes(route.path));
    return { showPublicChatbot };
  }
}
</script>
